// import {
//     FETCH_SUBSPACES_SUCCESS,
//     CREATE_SUBSPACE_SUCCESS,
//     UPDATE_SUBSPACE_SUCCESS,
//     DELETE_SUBSPACE_SUCCESS,
//   } from "../actions/subSpaces";
  
//   const initialState = {
//     subspaces: [],
//     totalSubSpaceCount: 0,
//   };
  
//   const subSpacesReducer = (state = initialState, action) => {
      
//       switch (action.type) {
//           case FETCH_SUBSPACES_SUCCESS:
//               console.log(action.payload.subspaces,"111111");
//               return {
//                   ...state,
//                   subspaces:action.payload.subspaces,
//                   totalSubSpaceCount: action.payload.totalSubSpaceCount,
//                 };
  
//       case CREATE_SUBSPACE_SUCCESS:
//         return {
//           ...state,
//           subspaces: [...state.subspaces, action.payload],
//         };
  
//       case UPDATE_SUBSPACE_SUCCESS:
//         return {
//           ...state,
//           subspaces: state.subspaces.map((subspace) =>
//             subspace.id === action.payload.id ? action.payload : subspace
//           ),
//         };
  
//       case DELETE_SUBSPACE_SUCCESS:
//         return {
//           ...state,
//           subspaces: state.subspaces.filter((subspace) => subspace.id !== action.payload),
//         };
  
//       default:
//         return state;
//     }
//   };
  
//   export default subSpacesReducer;
  
import {
    FETCH_SUBSPACES_SUCCESS,
    CREATE_SUBSPACE_SUCCESS,
    UPDATE_SUBSPACE_SUCCESS,
    DELETE_SUBSPACE_SUCCESS,
  } from "../actions/subSpaces";
  
  const initialState = {
    subspaces: [],
    totalSubSpaceCount: 0,
  };
  
  const subSpacesReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_SUBSPACES_SUCCESS:
        console.log(action.payload.subspaces, "Fetched SubSpaces");
        return {
          ...state,
          subspaces: action.payload.subspaces,
          totalSubSpaceCount: action.payload.totalSubSpaceCount,
        };
  
      case CREATE_SUBSPACE_SUCCESS:
        
        console.log(action.payload,"payload");
        return {
          ...state,
          subspaces: [...state.subspaces, action.payload], // Add the new subspace to the existing list
          totalSubSpaceCount: state.totalSubSpaceCount + 1, // Increment total count
        };
  
      case UPDATE_SUBSPACE_SUCCESS:
        return {
          ...state,
          subspaces: state.subspaces.map((subspace) =>
            subspace.id === action.payload.id ? { ...subspace, ...action.payload } : subspace
          ), // Update the matching subspace by ID
        };
  
      case DELETE_SUBSPACE_SUCCESS:
        return {
          ...state,
          subspaces: state.subspaces.filter((subspace) => subspace.id !== action.payload), // Remove the subspace by ID
          totalSubSpaceCount: state.totalSubSpaceCount - 1, // Decrement total count
        };
  
      default:
        return state;
    }
  };
  
  export default subSpacesReducer;
  